module.exports = __webpack_public_path__ + "static/media/BillMeireles.08a53a70.jpg";